
























































import { LessonDTO } from '../../../src_server/entity/dto/LessonDTO';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { LessonStates } from '../../../src_server/entity/master/LessonStates';
import { dayjs, DTW_FORMAT_JA, T_FORMAT_JA } from '../../../src_server/common/momentExtends';
import { routeHelper } from '../../utils/routeHelper';

@Component({
  components: {},
  filters: {
    dateFormat(date: Date) {
      return dayjs(date).format(DTW_FORMAT_JA);
    },
    dtFormat(date: Date) {
      return dayjs(date).format(T_FORMAT_JA);
    },
  },
})
export default class TeacherLessonStatusRow extends Vue {
  @Prop({ default: new LessonDTO() })
  private dto!: LessonDTO;

  get isAlready() {
    return this.dto.lessons.reservation_state === LessonStates.ALREADY;
  }

  get isTransfer() {
    return this.dto.lessons.reservation_state === LessonStates.TRANSFAR;
  }

  get isPast() {
    return dayjs(this.dto.lessons.start_dt).diff(dayjs()) < 0;
  }

  gotoDailyReport(row: LessonDTO) {
    this.$emit('goto-daily-report', row);
  }
  message(row: LessonDTO) {
    this.$emit('message', row);
  }
  transfer(row: LessonDTO) {
    this.$emit('transfer', row);
  }
  showPersonalPlan(row: LessonDTO) {
    const student_user_id = row.student?.user_id;
    routeHelper(this, 'SupportPlanPageFroTeacher', { user_id: student_user_id });
  }
}
